<template>
  <div class="user-card" @click="$emit('show-popup', user)">
    <div class="card-number">{{ index }}</div>
    <div class="user-info">
      <p class="user-email">{{ user.email }}</p>
      <p class="login-time">{{ formatTime(user.timestamp) }}</p>
      <p class="user-ip">{{ user.ip || 'Unknown IP' }}</p>
      <p class="user-agent">{{ truncateUserAgent(user.userAgent) }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UserCard',
  props: {
    user: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
  },
  methods: {
    formatTime(timestamp) {
      return new Date(timestamp).toLocaleString();
    },
    truncateUserAgent(userAgent) {
      return userAgent ? userAgent.substring(0, 50) + '...' : 'Unknown';
    },
  },
};
</script>

<style scoped>
.user-card {
  background-color: var(--card-background);
  border-radius: 10px;
  padding: 20px;
  position: relative;
  overflow: hidden;
  cursor: pointer;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  box-shadow: var(--card-shadow);
}

.user-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.15);
}

.card-number {
  position: absolute;
  top: -10px;
  right: -10px;
  background-color: var(--accent-color);
  color: var(--text-color);
  font-size: 24px;
  font-weight: bold;
  width: 40px;
  height: 40px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
}

.user-info p {
  margin: 5px 0;
}

.user-email {
  font-weight: bold;
  color: var(--primary-color);
}

.login-time {
  font-size: 14px;
  color: var(--text-color);
}

.user-ip, .user-agent {
  font-size: 12px;
  color: var(--text-color);
  opacity: 0.8;
}
</style>

